(function () {
  if (window.__carniShareBound) return;
  window.__carniShareBound = true;
  function closeAll() {
    document.querySelectorAll('[data-carni-share-overlay]:not([hidden])').forEach(function (ov) {
      if (window.CarniModal) CarniModal.close(ov);
      else { ov.hidden = true; document.documentElement.style.overflow = ''; }
    });
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var openBtn = e.target.closest('[data-carni-share-open]');
    if (openBtn) {
      var root = openBtn.closest('[data-carni-share]');
      var ov = root && root.querySelector('[data-carni-share-overlay]');
      if (ov) {
        // CarniModal handles the scroll lock (including the nested-host case),
        // the focus trap, focus restore and the Escape key.
        if (window.CarniModal) CarniModal.open(ov, { trigger: openBtn });
        else {
          ov.hidden = false;
          if (!openBtn.closest('quick-view-modal, modal-component, drawer-component, .drawer')) {
            document.documentElement.style.overflow = 'hidden';
          }
        }
      }
      return;
    }
    if (e.target.closest('[data-carni-share-close]')) { closeAll(); return; }
    // backdrop click: the overlay itself, not the modal within it
    if (e.target.matches && e.target.matches('[data-carni-share-overlay]')) { closeAll(); return; }
    var copyBtn = e.target.closest('[data-carni-share-copy]');
    if (copyBtn) {
      var box = copyBtn.closest('.carni-share__copy');
      var urlInput = box && box.querySelector('.carni-share__url');
      var label = copyBtn.querySelector('.carni-share__copybtn-label') || copyBtn;
      var done = copyBtn.getAttribute('data-done') || 'Copied!';
      var orig = label.textContent;
      var ok = function () { label.textContent = done; copyBtn.classList.add('is-done'); setTimeout(function () { label.textContent = orig; copyBtn.classList.remove('is-done'); }, 1800); };
      var val = urlInput ? urlInput.value : '';
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(val).then(ok).catch(function () { try { urlInput.select(); document.execCommand('copy'); ok(); } catch (_) {} });
      } else { try { urlInput.select(); document.execCommand('copy'); ok(); } catch (_) {} }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !window.CarniModal) closeAll();
  });
})();
